<template>
  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu"><nav-header active-index="env"></nav-header></el-header>


    <el-main id="router_view">
      <el-row>
        <!--左侧菜单-->
        <el-col  id="menu_container" :span="menuSpan">
          <ih-signal-vertical-tabs
            :activeTab="activeTab"
            :mTabs="mTabs" @tabChanged="menuClicked" v-show="(activeIndex =='env' ||activeIndex =='pop'  )"></ih-signal-vertical-tabs>
        </el-col>

        <!--地图容器-->
        <el-col :span="mapSpan" style="position: relative">
          <!-- Map container-->
          <div id="map" style="width: 100%; z-index: 1; background-color: lightcyan;"></div>

          <div  id="mapResizeButton"
                style="cursor: pointer;
                background-color: rgb(67,133,185); width: 27px; height: 98px;padding: 2px;border-radius: 3px; border: 3px solid rgb(135,206,235)">
            <img :src="zoomIn" style="width: 100%; color: white;margin-left: -1px; width: 30px;height: 30px;" title="Operation manual"  @click="openOperationMenu"/>
            <img :src="zoomOut" style="width: 100%; color: white;margin-top: 5px; margin-bottom: 5px; width: 22px;height: 22px;" @click="openDescriptionDlg"/>
            <img :src="menuResizeIcon" style="width: 100%; color: white;width: 25px;height: 25px;" @click="mapResize"/>
          </div>

          <!--图例-->
          <map-lengend
            :title="lengedTitle"
            @colorsChanged="colorsChanged"
            ref="ref_mapLegend"
            :legends="selectedMapLegendsStyle"
            class="legend"
            id="IDLegend"
            @layoutupdate="legend_layoutupdate"
            style="display: none;">
          </map-lengend>


          <!--map layer source name  | toolabs-->
          <div class="css_map_footer" >
            <div class="bg"></div>
            <div class="context">

              <!-- map source name-->
              {{ selectedRasterMapSrouce.toUpperCase()}}
              <a id="image-download" download="map.png"></a>
              <img  :src="file_download"  style="float: left;margin-left: 10px; margin-top: 5px;width: 30px;height: 30px;" @click="mapExport"/>
              <img v-show="mapDocBt_visible" :src="file_detail"  style="float: left;margin-left: 15px; margin-top: 6px;width: 26px;height: 26px;" @click="mapDeitalView"/>
              <!--map legend controller-->
              <div style="float:right; width: 25px;height: 25px;margin-right: 5px;" @click="legend_layoutupdate_show">
                <img v-show="mapLengends_visible" :src="legendModel==0?icon_zhankai_w:icon_shousuo_w" style="width: 100%; margin-top: 7px;" >
              </div>
            </div>

          </div>


          <!-- overlay-->
          <div id="popup" class="ol-popup">
            <el-row style="background-color: transparent; line-height: 30px; height: 30px; width: 120px;">
              <el-col :span=20 style="text-align: left;"><div style="padding-right: 20px;">{{
                  selectedRasterMapData=="NO DATA"?"NO DATA":parseFloat(selectedRasterMapData).toFixed(2)
                }}</div></el-col>
              <el-col :span=4 style="text-align: right;">
                <a href="#" id="popup-closer" class="ol-popup-closer" style="font-size: 17px;"></a>
              </el-col>
            </el-row>
          </div>

        </el-col>



      </el-row>
    </el-main>




    <el-dialog
      title="About the Global Change Risk Map Platform of Population and Economic Systems"
      :visible.sync="descriptionDlgVisible"
      top="70px"
      width="60%"
      :before-close="closeDescriptionDlg">
      <div style="text-align: left;width: 100%; font-size: 16px;" id="DLGContent" ref="REFDLGContent">
      </div>
    </el-dialog>


  </el-container>
</template>

<script>

import  ihMap  from "@/components/map/IHMap";
import  ihVerticalTabs from "@/components/widgets/IHVerticalTabs";
import  ihSignalVerticalTabs from "@/components/widgets/IHSignalVerticalTabs";
import  mapLengend from "@/view/BSD/components/MapLengend";


import 'ol/ol.css'
import {toSize} from 'ol/size';
import {menus_env,menus_risk,cascaderData} from "./BSDConfig"

import {TDM_LAYER_VEC_C,BSD_TDM_LAYER_EVA_C,TDM_LAYER_IMG_C} from "../../components/map/common/constant"
import Overlay from 'ol/Overlay';
import AppConfig from "./AppConfig";
//Init Icon Params
let menuresizeicon_min =  require( '../../assets/icons/menu_shousuo_w.png');
let menuresizeicon_max =  require( '../../assets/icons/menu_zhankai_w.png');
let icon_zhankai_w =  require( '../../assets/icons/icon_zhankai_w.png');
let icon_shousuo_w =  require( '../../assets/icons/icon_shousuo_w.png');
let bsd_logo =  require( '../../../src/assets/icons/earth.png');
let file_download =  require( '../../assets/icons/download.png');
let file_detail =  require( '../../assets/icons/查看详情.png');

let bunMenuIcon =  require( '../../assets/imgs/bunMenu.png');
let menuresizeicon_description =  require( '../../assets/icons/description.png');

import {geoserver,geoserver_local,geoserver_local_tiff,geoserver_basic} from "./GEOConfig"
import NavHeader from "./components/NavHeader";
import {reverseMapLegend} from "./mapTools";
import BSDConfigLegendTitle from "./BSDConfigLegendTitle_CC";

import {api_bnu_getLayerLegends ,api_bnu_docDownloadTimes} from "@/api";

let mapZoomIn =  require( '../../assets/icons/加号.png');
let mapZoomOut =  require( '../../assets/icons/减号.png');
export default {
  name: "BSDMap",
  components:{ihMap,ihVerticalTabs,ihSignalVerticalTabs,mapLengend,NavHeader},
  data(){
    return {
      zoomIn:mapZoomIn,
      zoomOut:mapZoomOut,
      mapDocBt_visible:false,
      mapLengends_visible:false,
      activeIndex: 'env',
      menuSpan:0,
      mapSpan:24,
      menuSpan_max:3,
      mapSpan_min:21,
      menu_width:null,
      content_height:null,
      menuResizeIcon: menuresizeicon_max,
      logo: bsd_logo,
      //菜单配置
      mTabs:menus_env,
      //地图相关的
      map:null,
      vector_layer:null,
      geoserver:geoserver,
      geoserver_local:geoserver_local,
      geoserver_local_tiff:geoserver_local_tiff,
      geoserver_basic:geoserver_basic,
      //
      lastClicedMenuItem:undefined,
      mapUtils:null,
      //Radio Group Data
      radioData:undefined,
      radioG_cc_prcptot:"ann",
      //Cascader
      default_activemenu_cc:'cc_tmean_mean',
      selected_cascader:["2000_s0"],
      cascader_options:cascaderData["cc_prcptor"],
      radioG_cc_prcptot_type:"value",
      radioG_cc_prcptot_mm:"mme",
      selectedRasterMapSrouce:"World political map",
      //legend
      legendModel:0,
      icon_zhankai_w,
      icon_shousuo_w,
      file_download,
      file_detail,

      //overlay
      defaultMapOverlay:undefined,
      selectedRasterMapData:undefined,
      selectedMapLegendsStyle:undefined,
      //
      loginUser:undefined,
      defaultRasterLayerName:"olRasterLayer",
      //
      selected_workspace:undefined,
      selected_layer_code:undefined,

      selectedRasterMapLayer:undefined,
      basicOceanLayer:undefined,
      descriptionDlgVisible:false,
      bunMenuIcon,menuresizeicon_description,
      lengedTitle:"Legend",

      activeTab:4
    }
  },
  created() {

    this.switchToPage()
    // this.lastClicedMenuItem= sm;
    // this.activeTab = this.readActiveTag(sm);
    //this.lastClicedMenuItem = "world_political_map";
  },
  methods:{

    switchToPage(){
      let sm = this.$route.query.sm
      this.lastClicedMenuItem= sm;
      this.activeTab = this.readActiveTag(sm);
    },
    readActiveTag(sm){
      let _activeTab=0;
      switch (sm) {
        case "world_political_map":
          _activeTab=0;
          break;
        case "global_satellite_image":
          _activeTab=1;
          break;
        case "global_elevation":
          _activeTab=2;
          break;
        case "global_climate_zones":
          _activeTab=3;
          break;
        case "global_soil":
          _activeTab=4;
          break;
      }
      return _activeTab;
    },

    //app's operation menu
    openOperationMenu(){
      //window.open(AppConfig.minio_server+"/bun/Manual%20for%20the%20use%20of%20the%20global%20typical%20disaster%20risk%20digital%20mapping%20platform.docx","_blank");
      let mzoom = this.map.getView().getZoom();
      if(mzoom>=18){
        return;
      }
      let mcenter = this.map.getView().getCenter();
      this.map.getView().setZoom(mzoom+1);
      this.map.getView().setCenter(mcenter);
    },

    //打开属性对话框
    openDescriptionDlg(){
      //this.descriptionDlgVisible = true;
      let mzoom = this.map.getView().getZoom();
      if(mzoom>1){
        let mcenter = this.map.getView().getCenter();
        this.map.getView().setZoom(mzoom-1);
        this.map.getView().setCenter(mcenter);
      }

    },

    closeDescriptionDlg(){
      this.descriptionDlgVisible = false;
    },

    colorsChanged(colorGroups){
      console.log("BSDMapEnv::colorsChanged");
      this.selectedMapLegendsStyle = colorGroups;
      this.dynamicLodingWMSLayerAfterMapLengendsUpdate();
    },

    /**
     * 查询地图点击查询值
     * */
    readMapPoint(evt){

      this.defaultMapOverlay.setPosition(undefined);
      //校验点是否有效
      let view = this.map.getView();
      let viewResolution = view.getResolution();
      let source =this.basicOceanLayer.getSource();
      let url = source.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        view.getProjection(),
        {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});
      let _this = this;
      this.axios.get(url).then((response)=>{
        console.log("checkQueryPointValid::response.data = ",response.data);
        const selectedFeatures =response.data.features;
        if(selectedFeatures.length==0){
          _this.readSelectedPointData(evt);
        }
      })
    },


    readSelectedPointData(evt){
      var view = this.map.getView();
      var viewResolution = view.getResolution();
      var source =this.selectedRasterMapLayer.getSource();
      var url = source.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        view.getProjection(),
        {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});

      console.log("url = ",evt);
      this.axios.get(url).then((response)=>{
        console.log("response.data = ",response.data);
        const selectedFeatures =response.data.features;
        if(selectedFeatures.length>0) {
          const selectedFeature = selectedFeatures[0];
          const selectedFeature_properties = selectedFeature.properties;
          this.selectedRasterMapData = selectedFeature_properties.GRAY_INDEX;
          console.log("this.selectedRasterMapData = ",this.selectedRasterMapData);

          if(this.selectedRasterMapData==null){
            this.selectedRasterMapData = "NO DATA";
            this.defaultMapOverlay.setPosition(evt.coordinate);
            return;
          }

          //处理科学基数
          if(this.selectedRasterMapData!=undefined){
            console.log("处理科学基数");
            let raster_rate = this.getRasterValueRate();
            console.log("raster_rate = ",raster_rate);
            this.selectedRasterMapData = parseFloat(this.selectedRasterMapData)*this.getRasterValueRate();
          }

          if((this.selectedRasterMapData && this.selectedRasterMapData !=null) || parseFloat(this.selectedRasterMapData)!=0){
            if(parseFloat(this.selectedRasterMapData)<0){
              let selectedRasterMapData_str = this.selectedRasterMapData+" ";
              if(selectedRasterMapData_str.indexOf("e+")>-1){
                console.log("negitive value && value is too small");
                this.selectedRasterMapData = "NO DATA";
              }
            }
            this.defaultMapOverlay.setPosition(evt.coordinate);
          } else {
            this.defaultMapOverlay.setPosition(undefined);
          }
        }
      })
    },

    getRasterValueRate(){
      let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
      let rate = undefined;
      let title = BSDConfigLegendTitle[current_layer_code];
      if(title!=undefined){
        let title_seg = title.split("#");
        title_seg.forEach(item=>{
          if(item.indexOf("^")>-1){
            rate = item.split("^")[1]
          }
        })
      }
      let raster_value_rate = 1;
      if(rate!=undefined){
        for(let i=0;i<rate;i++){
          raster_value_rate = raster_value_rate*(0.1);
        }
      }
      return raster_value_rate;
    },

    initMapOverlay(){
      if(this.map && this.defaultMapOverlay==undefined){
        var container = document.getElementById('popup');
        var closer = document.getElementById('popup-closer');
        var overlay = new Overlay({
          element: container,
          autoPan: true,
          autoPanAnimation: {
            duration: 250,
          },
        });
        closer.onclick = function () {
          overlay.setPosition(undefined);
          closer.blur();
          return false;
        };
        this.map.addOverlay(overlay);
        this.defaultMapOverlay = overlay;
      }
    },


    /*******************************************************************************************************************
     * 导航条部分
     * */
    switchFeedback(){
      let userData = this.$appStorage.getUserData();
      if(userData==undefined){
        this.$router.push({path:'/BNUMap/Login'})
      }else {
        this.$router.push({path:'/BNUMap/Feedback'})
      }
    },

    Login(){
      let userData = this.$appStorage.getUserMailbox();
      if(userData==undefined){
        this.$router.push({path:'/BNUMap/Login'})
      }else {
        alert(userData);
      }
    },

    handleSelect(key) {
      this.activeIndex = key;
      console.log("key = ",key,"&activeIndex =",this.activeIndex);
      if(key =="env")
      {
        this.mTabs = menus_env;
      }
      else if(key=="risk") {
        this.mTabs = menus_risk;
      }

      let rPath = "/BNUMap/"+key;
      this.$router.push({path:rPath})
    },


    /*******************************************************************************************************************
     * 业务部分
     * */
    menuClicked:function (item) {
      console.log("menu clicked = ",item);
      this.lastClicedMenuItem = item;
      TDM_LAYER_VEC_C.setVisible(false);
      TDM_LAYER_IMG_C.setVisible(false);
      if(this.defaultRasterLayerName==undefined){
        this.$olMapUtils.removeLayerByName(this.map,this.defaultRasterLayerName);
      }
      if(this.defaultMapOverlay){
        this.defaultMapOverlay.setPosition(undefined);
      }

      if(this.selectedRasterMapLayer!=undefined){
        this.map.removeLayer(this.selectedRasterMapLayer);
        this.selectedRasterMapLayer = undefined;
      }


      this.mapDocBt_visible = true;
      this.mapLengends_visible = true;

      if(item=="world_political_map") {
        TDM_LAYER_VEC_C.setVisible(true);
        this.selectedRasterMapSrouce = "World political map";
        this.mapLengends_visible = false;
        this.mapDocBt_visible = false;
        document.getElementById("IDLegend").style.display = 'none';

        this.mapLengends_visible = false;
        this.legendModel = 1;

        this.basicMap(false);
      }else if(item=="global_satellite_image"){

        TDM_LAYER_IMG_C.setVisible(true);
        this.selectedRasterMapSrouce = "Global Satellite Image";
        this.mapLengends_visible = false;
        this.mapDocBt_visible = false;
        document.getElementById("IDLegend").style.display = 'none';
        this.mapLengends_visible = false;
        this.legendModel = 1;
        this.basicMap(false);
      }
      else if(item=="global_elevation"){
        console.log("item==\"global_elevation\"");
        this.selectedRasterMapSrouce = "Global elevation";

        console.log("dynamicLodingWMSLayer");
        this.dynamicLodingWMSLayer("global_digital_elevation_models","etopo1_bed_g_geotiff");
        this.basicMap(true);

        this.legendModel=0;
        this.mapLengends_visible = true;
        this.legend_layoutupdate_show();
        this.lengedTitle = "Elevation(m)";
      }
      else if(item=="global_terrain_slope"){
        this.dynamicLodingWMSLayer("global_terrain_slope","slope_wgs");
        this.selectedRasterMapSrouce = "Global terrain slope";
        this.basicMap(true);

        this.legendModel=0;
        this.mapLengends_visible = true;
        this.legend_layoutupdate_show();
      }
      else if(item=="global_climate_zones"){
        this.dynamicLodingWMSLayer("global_climate_zones","clim");
        this.selectedRasterMapSrouce = "Global climate zones";
        this.basicMap(true);

        this.legendModel=0;
        this.mapLengends_visible = true;
        this.legend_layoutupdate_show();
        this.lengedTitle = "Climate zones";
      }
      else if(item=="global_river_system"){
        this.selectedRasterMapSrouce = "Global river system";
        this.basicMap(true);
        this.mapLengends_visible = false;
        this.$message({
          message: 'No Data',
          type: 'warning'
        });

        this.legendModel=0;
        this.mapLengends_visible = true;
        this.legend_layoutupdate_show();
      }
      else if(item=='global_soil'){
        this.dynamicLodingWMSLayer("global_soil","soil");
        this.selectedRasterMapSrouce = "Global soil";
        this.basicMap(true);

        this.legendModel=0;
        this.mapLengends_visible = true;
        this.legend_layoutupdate_show();

        this.lengedTitle = "Soil";
      }
      else if(item=="global_land_cover"){
        this.dynamicLodingWMSLayer("landcover","probav_lc100_global_v301_2019_nrt_discrete_classification_map_epsg_4326");
        this.selectedRasterMapSrouce = "Global land cover";
        this.basicMap(true);

        this.legendModel=0;
        this.mapLengends_visible = true;
        this.legend_layoutupdate_show();
      }

      this.activeTab = this.readActiveTag(item);
    },


    /**
     * @author zhangchegnguo
     * @description  动态加载图层
     * */
    dynamicLodingWMSLayer(workspace,layer_code){
      console.log("dynamicLodingWMSLayer-1");
      this.selected_workspace = workspace;
      this.selected_layer_code = layer_code;

      workspace = workspace.toLowerCase();
      let tifflayer_accessurl = this.geoserver_basic+workspace+"/wms";

      this.updateMapLengends(layer_code,workspace);

      if(this.selectedRasterMapLayer!=undefined){
        this.map.removeLayer(this.selectedRasterMapLayer);
        this.selectedRasterMapLayer = undefined;
      }

      this.selectedRasterMapLayer = this.$olMapUtils.addWMSLayer({
        defaultStyles:undefined,
        layerName:this.defaultRasterLayerName,
        layerCode:this.selected_layer_code,
        visible:true,
        geoServer:tifflayer_accessurl,
        zIndex:0});

      let _this = this;
      setTimeout(function () {
        _this.$refs.ref_mapLegend.updateHeight();
      },100)
    },

    /**
     * 图例颜色修改后，更新视图
     * **/
    dynamicLodingWMSLayerAfterMapLengendsUpdate(){
      console.log("mapLegends::dynamicLodingWMSLayerAfterMapLengendsUpdate");

      if(this.selectedRasterMapLayer!=undefined){
        this.map.removeLayer(this.selectedRasterMapLayer);
        this.selectedRasterMapLayer = undefined;
      }


      let styleData= this.$olMapUtils.colorGroupReverse_NODATA_BLACK(this.selectedMapLegendsStyle);
      let layerSytleColorGroups =this.$olMapUtils.parseSLDBodyWithType(this.$x2js,this.selected_layer_code, styleData,"RAMP");
      console.log("this.selectedMapLegendsStyle = ",JSON.stringify(styleData));

      let tifflayer_accessurl = this.geoserver_basic+this.selected_workspace+"/wms";
      console.log("tifflayer_accessurl = ",tifflayer_accessurl);
      this.selectedRasterMapLayer = this.$olMapUtils.addWMSLayer({
        defaultStyles:layerSytleColorGroups, //关闭动态Style文件
        layerName:this.defaultRasterLayerName,
        layerCode:this.selected_layer_code,
        visible:true,
        geoServer:tifflayer_accessurl,
        zIndex:0});

    },


    updateMapLengends(layer_code,wms_ws){

      let legends_params_layercode = layer_code;
      let legends_params_layercodes = legends_params_layercode.split(":");
      legends_params_layercode = legends_params_layercodes[legends_params_layercodes.length-1];
      let legends_params = {
        layerName:legends_params_layercode,
        workspace:wms_ws};
      console.log("api_bnu_getLayerLegends::prams = ",legends_params);
      api_bnu_getLayerLegends(legends_params).then(res=>{
        console.log("api_bnu_getLayerLegends:: data = ",res.data);
        let res_data = res.data;
        if(res_data==undefined||res_data.length==0){
          this.$message.error("Style DATA UNDEFINED");
        }
        else {
          let res_data_data = res_data.data;
          let selectedSLDFile = JSON.parse(res_data_data);
          console.log("obj_resData.data = ",selectedSLDFile);
          this.selectedMapLegendsStyle = reverseMapLegend(selectedSLDFile);
          if(this.legendModel==1){
            this.$refs.ref_mapLegend.updateHeight();
          }
        }
      })
    },

    // updateMapLengends(){
    //   let item = this.lastClicedMenuItem;
    //   console.log("updateMapLengends && item = ",item);
    //   let selectedSLDFile = undefined;
    //   if(item=="world_political_map"){
    //     // selectedSLDFile =rp_ext;
    //   }else if(item=="global_satellite_image"){
    //     // selectedSLDFile =rp_mean;
    //   }else if(item=="global_elevation"){
    //     selectedSLDFile =global_digital_elevation_models;
    //   } else if(item=="global_terrain_slope"){
    //     selectedSLDFile =global_terrain_slope;
    //   } else if(item=="global_climate_zones"){
    //     selectedSLDFile =global_climate_zones;
    //   }else if(item=="global_river_system"){
    //     // selectedSLDFile =rt_var;
    //   } else if(item=='global_soil'){
    //     selectedSLDFile =global_soil;
    //   }else if(item=="global_land_cover"){
    //     selectedSLDFile =landcover;
    //   }
    //
    //   console.log("selectedSLDFile = ",selectedSLDFile);
    //
    //   if(selectedSLDFile){
    //     this.selectedMapLegendsStyle = reverseMapLegend(selectedSLDFile);
    //   }else{
    //     this.selectedMapLegendsStyle = undefined;
    //     alert("The Style File of The Layer Can Not Find!");
    //   }
    //
    //   console.log("update height - start");
    //   this.$refs.ref_mapLegend.updateHeight();
    //   console.log("update height - end");
    //
    // },


    /*******************************************************************************************************************
     * init the map container
     * */
    initMap:function () {
      if(this.map!=undefined){
        this.map = undefined;
      }
      this.map = this.$olMapUtils.init({
        map:document.getElementById("map"),
        center:[108.320382,34.30981],
        initZoom:4,
        geoserver:this.geoserver_local});

      let _this = this;
      this.map.on('click', function (event) {
        var coordinate = event.coordinate;
        var _map = event.target;
        var pixel =_map.getPixelFromCoordinate(coordinate);
        console.log("pixel = ",pixel);

        if(_this.selectedRasterMapLayer){
          _this.readMapPoint(event);
        }
      });


      this.basicOceanLayer =this.$olMapUtils.addWMSLayer({layerName:"bsd:ocean", layerCode:"bsd:ocean", visible:true,zIndex:9,});
      this.$olMapUtils.addWMSLayer({layerName:"bsd:country",layerCode:"bsd:country_project",visible:true,zIndex:10});
      this.$olMapUtils.addWMSLayer({visible:false,layerCode:"bsd:geogrid_4326",zIndex:12});
      this.$olMapUtils.addWMSLayer({visible:false,layerCode:"bsd:military_border",zIndex:13});
      this.$olMapUtils.addWMSLayer({visible:false,layerCode:"bsd:undefine_country_border",zIndex:14});

      this.map.addLayer(BSD_TDM_LAYER_EVA_C);
      BSD_TDM_LAYER_EVA_C.setZIndex(15);

      this.map.addLayer(TDM_LAYER_VEC_C);
      TDM_LAYER_VEC_C.setZIndex(7);
      TDM_LAYER_VEC_C.setVisible(false);

      this.map.addLayer(TDM_LAYER_IMG_C);
      TDM_LAYER_IMG_C.setZIndex(8);
      TDM_LAYER_IMG_C.setVisible(false);
    },

    basicMap(visible){
      this.$olMapUtils.getLayerByName(this.map,"bsd:ocean").setVisible(visible);
      this.$olMapUtils.getLayerByName(this.map,"bsd:country").setVisible(visible);
      this.$olMapUtils.getLayerByName(this.map,"bsd:geogrid_4326").setVisible(visible);
      this.$olMapUtils.getLayerByName(this.map,"bsd:military_border").setVisible(visible);
      this.$olMapUtils.getLayerByName(this.map,"bsd:undefine_country_border").setVisible(visible);
    },



    initLayout(){

      const screen_height = document.body.clientHeight;
      const page_header = 60;
      const content_height = screen_height -  page_header;
      document.getElementById("root_container").style.height = document.body.clientHeight+"px";
      document.getElementById("router_view").style.height = document.body.clientHeight - 60+"px";
      document.getElementById("map").style.height = document.body.clientHeight - 60+"px";
      document.getElementById("menu_container").style.height =content_height+"px";

      this.menu_width = document.getElementById("menu_container").clientWidth;
      this.content_height = document.body.clientHeight - 60;
      document.getElementById("mapResizeButton").style.top ="5px";
      document.getElementById("mapResizeButton").style.marginLeft ="5px";
    },

    mapResize(){
      if(this.menuSpan==3) {
        this.menuSpan = 0;
        this.mapSpan = 24;
        this.map.setSize(new toSize([document.body.clientWidth ,this.content_height]));
        this.menuResizeIcon = menuresizeicon_max;
      } else {
        this.menuSpan = 3;
        this.mapSpan = 21;
        this.map.setSize(new toSize([(document.body.clientWidth - this.menu_width),this.content_height]));
        this.menuResizeIcon = menuresizeicon_min;
      }
    },

    /**
     *
     * */
    mapSourceLayout(){
      if(this.selectedRasterMapSrouce==undefined){
        document.getElementById("IDLegend").style.bottom = "40px";
      } else {
        document.getElementById("IDLegend").style.bottom = "40px";
      }
    },

    legend_layoutupdate(data){
      let obj = document.getElementById("IDLegend");
      obj.style.bottom = (0-parseInt(data))-50 +"px";
    },

    legend_layoutupdate_close(){
      //没有图例的情况下，屏蔽当前按钮
      this.mapLengends_visible = false;

      let obj = document.getElementById("IDLegend");
      obj.style.bottom = "40px";
      this.legendModel = 0;

      document.getElementById("IDLegend").style.display = 'none';
      this.$refs.ref_mapLegend.updateHeight();
    },


    legend_layoutupdate_show(){
      //没有图例的情况下，屏蔽当前按钮
      if(!this.mapLengends_visible){
        return ;
      }

      let obj = document.getElementById("IDLegend");
      obj.style.bottom = "40px";

      if(this.legendModel==0){
        this.legendModel=1;
        document.getElementById("IDLegend").style.display = 'block';
      }else {
        this.legendModel = 0;
        document.getElementById("IDLegend").style.display = 'none';
      }

      this.$refs.ref_mapLegend.updateHeight();
    },

    /**
     * @description 地图详情预览
     * */
    mapDeitalView(){
      window.open("https://cbcdn.cafewallet.cn/docfile/FileDownlaodTtest_20201127.docx","_blank");
    },






    /**
     * @author zhangchengguo
     * @description 导出地图文件
     * */
    doMapExport(){
      let _map = this.map;
      this.map.once('rendercomplete', function () {
        var mapCanvas = document.createElement('canvas');
        var size =_map.getSize();
        mapCanvas.width = size[0];
        mapCanvas.height = size[1];
        var mapContext = mapCanvas.getContext('2d');
        Array.prototype.forEach.call(
          document.querySelectorAll('.ol-layer canvas'),
          function (canvas) {
            if (canvas.width > 0) {
              var opacity = canvas.parentNode.style.opacity;
              mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
              var transform = canvas.style.transform;
              // Get the transform parameters from the style's transform matrix
              var matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(',')
                .map(Number);
              // Apply the transform to the export map context
              CanvasRenderingContext2D.prototype.setTransform.apply(
                mapContext,
                matrix
              );
              mapContext.drawImage(canvas, 0, 0);
            }
          }
        );
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
        } else {
          var link = document.getElementById('image-download');
          link.href = mapCanvas.toDataURL();
          link.click();
        }
      });
      _map.renderSync();
    },

    mapExport(){
      console.log("BSDMapRISK::mapExport");
      let _this = this;
      api_bnu_docDownloadTimes({path:this.selectedRasterMapSrouce.toLowerCase()}).then(res=>{
        let rData = res.data;
        console.log("rData = ",rData);
        _this.doMapExport();
      })
    },






  },
  watch:{
    $route(to,from){
      console.log(from.path);//从哪来
      console.log(to.path);//到哪去
      let sm = this.$route.query.sm;
      this.menuClicked(sm);
    }
  },
  mounted()
  {
    this.initLayout();
    this.initMap();
    this.loginUser = this.$appStorage.getUserMailbox();
    this.selected_cascader =["2000s_s0"];

    //初始化操作
    this.menuSpan = 0;
    this.mapResize();

    TDM_LAYER_VEC_C.setVisible(true);
    this.initMapOverlay();

    this.legendModel = 0;
    this.legend_layoutupdate_show();
    this.basicMap(false);

    this.menuClicked(this.lastClicedMenuItem);

  }


}
</script>




<style scoped lang="scss">
@import "BSDMap";
</style>



// WEBPACK FOOTER //
// src/view/BSD/BSDMapEnv.vue